import { gql, useMutation, useQuery } from '@apollo/client'
import { useEffect } from 'react'

import {
  DeleteCartMutation,
  DeleteCartMutationVariables,
  StoreCartListQuery,
  StoreCartListQueryVariables,
  UserCartsConnectionFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useMessage } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { removeUserInfoRegisterRedirect } from '@/core/native/storage'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { showError } = useMessage()
  const { data, loading, fetchMore } = useQuery<
    StoreCartListQuery,
    StoreCartListQueryVariables
  >(QUERY, {
    notifyOnNetworkStatusChange: true,
    onError: showError,
  })

  const [deleteCart, { loading: deleting }] = useMutation<
    DeleteCartMutation,
    DeleteCartMutationVariables
  >(DELETE_CART)

  useEffect(() => {
    removeUserInfoRegisterRedirect()
  }, [])

  return {
    state: {
      loading,
      deleting,
      carts: data?.userCarts,
    },
    actions: {
      async onFetchMore() {
        fetchMore({
          variables: {
            pageInput: {
              cursor: data?.userCarts.pageInfo.endCursor,
            },
          },
        })
      },
      async onDeleteCart(cartId: string) {
        return deleteCart({
          variables: {
            inputs: {
              cartId,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query StoreCartList($pageInput: PageInput) {
    userCarts(pageInput: $pageInput) {
      ...UserCartsConnection
    }
  }
  ${UserCartsConnectionFragmentDoc}
`

const DELETE_CART = gql`
  mutation DeleteCart($inputs: DeleteCartInput!) {
    deleteCart(inputs: $inputs) {
      id
    }
  }
`
